<h2 mat-dialog-title>{{ 'bcmBerths.onlineBookingQr.title' | translate:{ handle: data.berthHandle } }}</h2>

<mat-dialog-content>
    <p class="qr-dialog-intro">{{ 'bcmBerths.onlineBookingQr.intro' | translate }}</p>

    <berth-online-booking-qr-panel
        [berthId]="data.berthId"
        [berthHandle]="data.berthHandle">
    </berth-online-booking-qr-panel>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button type="button" (click)="close()">{{ 'common.close' | translate }}</button>
</mat-dialog-actions>
